<div class="col-md-12">
    <div class="about-box">
        <label>{{'SITE_VERSION' | translate}}: </label> {{'SITE_VERSION_PREFIX' | translate}}-{{SiteVersion}}<br /><br />
        <label>{{'API_VERSION' | translate}}:</label> {{ApiVersion}}
    </div>
</div>
